import { get } from './api'

const TRACKING_PREFIX = '/blade-portal/tracking'

export const trackingService = {
  /**
   * 根据运单号查询物流轨迹 (访客可用)
   */
  async getTrackingInfo(trackingNumber) {
    const response = await get(`${TRACKING_PREFIX}/query`, { trackingNumber })
    return response
  },

  /**
   * 获取货物轨迹事件列表
   */
  async getTrackingEvents(params = {}) {
    const response = await get(`${TRACKING_PREFIX}/events`, {
      referenceType: params.referenceType,
      referenceId: params.referenceId,
    })
    return response
  },

  /**
   * 按报名ID获取轨迹
   */
  async getBookingTracking(bookingId) {
    const response = await get(`${TRACKING_PREFIX}/booking/${bookingId}`)
    return response
  },
}

export default trackingService
